import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  panelOpenState = false;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

logout(): void{
  localStorage.removeItem("rol")
  this.router.navigateByUrl('/login');
}
}
